import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import SectionRenderer from "../components/SectionRenderer";
import Seo from "../components/Seo";

export default function DynamicPage() {
  const { slug } = useParams();
  const { data: page, isLoading, isError } = useQuery({
    queryKey: ["page", slug],
    queryFn: async () => (await api.get(`/pages/${slug}`)).data,
    retry: false,
  });

  if (isLoading) return <div className="max-w-6xl mx-auto px-4 py-24"><div className="h-64 bg-slate-100 rounded-2xl animate-pulse" /></div>;
  if (isError || !page) return <div className="py-24 text-center text-slate-500">Page not found.</div>;

  return (
    <div>
      <Seo title={page.seo_title || page.title} description={page.seo_description || ""} />
      {(page.sections || []).map((s, i) => <SectionRenderer key={i} section={s} />)}
      {(!page.sections || page.sections.length === 0) && <div className="py-24 text-center text-slate-400">This page has no content yet.</div>}
    </div>
  );
}
